import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { AssetMetaData } from "~/components/TableView/NameCell/AssetNameCell/AssetMetaData";
import { PublicTableAssetTitle } from "~/components/TableView/NameCell/NameCellContent/PublicTableAssetTitle";
import { canSeeAssetVersions, canViewAssetDiscussions } from "~/utils/permissions/assetPermissions";
export const PublicAssetNameCellTitle = /*#__PURE__*/ memo((param)=>{
    let { onClick, onCmdClick, title, assetVersionCount, onCommentsClick, onVersionsClick, openCommentCount, pagesCount } = param;
    const { permissions } = usePublicPermissions();
    const canViewDiscussions = canViewAssetDiscussions(permissions);
    const canViewAssetVersions = canSeeAssetVersions(permissions);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative ml-3",
        "data-disableselect": "true",
        children: [
            /*#__PURE__*/ _jsx(PublicTableAssetTitle, {
                title: title,
                onClick: onClick,
                onCmdClick: onCmdClick
            }),
            /*#__PURE__*/ _jsx(AssetMetaData, {
                assetVersionCount: assetVersionCount,
                onCommentsClick: onCommentsClick,
                onVersionsClick: onVersionsClick,
                openCommentCount: openCommentCount,
                shouldShowDiscussions: canViewDiscussions,
                shouldShowVersions: canViewAssetVersions,
                pagesCount: pagesCount
            })
        ]
    });
});
PublicAssetNameCellTitle.displayName = "PublicAssetNameCellTitle";
